module.exports = __webpack_public_path__ + "img/task-bigcover.5cfdd8b8.png";